import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: 'mailto:' + _ctx.wantedInvoiceMail,
    class: "underline"
  }, _toDisplayString(_ctx.wantedInvoiceMail), 9, _hoisted_1))
}